import CercleBio from '../assets//animation/adc/cercle-bio.jpg';
import CercleBiomed from '../assets//animation/adc/cercle-biomed.png';
import CercleChige from '../assets//animation/adc/cercle-chige.jpg';
import CercleDroit from '../assets//animation/adc/cercle-droit.jpg';
import CercleEMCP from '../assets//animation/adc/cercle-emcp.jpg';
import CercleInfo from '../assets//animation/adc/cercle-info.jpg';
import CercleMath from '../assets//animation/adc/cercle-math.jpg';
import CercleMed from '../assets//animation/adc/cercle-medecine.jpg';
import CerclePharma from '../assets//animation/adc/cercle-pharma.jpg';
import CerclePhilo from '../assets//animation/adc/cercle-philo.jpg';
import CercleVt from '../assets//animation/adc/cercle-vt.jpg';

import RevueDroit from '../assets//animation/revue/revue-droit.png';
import RevueEMCP from '../assets//animation/revue/revue-emcp.png';
import RevueMed from '../assets//animation/revue/revue-med.png';
import RevuePhilo from '../assets//animation/revue/revue-philo.jpg';
import RevueSciences from '../assets//animation/revue/revue-sciences.png';

import Ekot from '../assets//animation/akap/ekot.png';
import Impronam from '../assets//animation/akap/impronam.png';
import Kotejeux from '../assets//animation/akap/kotejeux.png';
import LesBrasDroits from '../assets//animation/akap/les-bras-droits.jpg';
import KapNord from '../assets//animation/akap/kapnord.jpg';
import MaisonInter from '../assets//animation/akap/maison-inter.jpg';
import KoteSport from '../assets//animation/akap/kotesport.jpg';
import NomDeLaRose from '../assets//animation/akap/nom-de-la-rose.jpg';
import KoteLocal from '../assets//animation/akap/kotelocal.jpg';
import CoKot from '../assets//animation/akap/cokot.png';
import BioKot from '../assets//animation/akap/biokot.jpg';
import Universeh from '../assets//animation/akap/universeh.jpg';
import KoteMarmots from '../assets//animation/akap/kotemarmots.png';
import Kaptivant from '../assets//animation/akap/kaptivant.png';
import UneFoisNamur from '../assets//animation/akap/une-fois-namur.jpg';
import ChezMarsha from '../assets//animation/akap/chez-marsha.jpg';
import KoteDemain from '../assets//animation/akap/kotedemain.jpg';
import Inclusio from '../assets//animation/akap/inclusio.jpg';

import Binchoise from '../assets//animation/regios/binchoise.png';
import Brabo from '../assets//animation/regios/brabo.jpg';
import BW from '../assets//animation/regios/bw.jpg';
import Carolo from '../assets//animation/regios/carolo.jpg';
import Chimacienne from '../assets//animation/regios/chimacienne.jpg';
import Destuna from '../assets//animation/regios/destuna.png';
import Liegeoise from '../assets//animation/regios/liegeoise.jpg';
import Lux from '../assets//animation/regios/lux.jpg';
import Namuroise from '../assets//animation/regios/namuroise.png';
import RTM from '../assets//animation/regios/rtm.jpg';

const animationData = {
    'adc': [
        {
            'name': 'Cercle Bio',
            'logo': CercleBio,
            'facebook': 'https://www.facebook.com/profile.php?id=100064342763803&locale=fr_FR',
        },
        {
            'name': 'Cercle Biomed',
            'logo': CercleBiomed,
            'facebook': 'https://www.facebook.com/BiomedUNamur?locale=fr_FR',
        },
        {
            'name': 'Cercle Chige',
            'logo': CercleChige,
            'facebook': 'https://www.facebook.com/lestartesauxabricotssontmeilleures?locale=fr_FR',
        },
        {
            'name': 'Cercle Droit',
            'logo': CercleDroit,
            'facebook': 'https://www.facebook.com/CercleDroitDeNamur?locale=fr_FR',
        },
        {
            'name': 'Cercle EMCP',
            'logo': CercleEMCP,
            'facebook': 'https://www.facebook.com/CercleEcoNamur?locale=fr_FR',
        },
        {
            'name': 'Cercle Info',
            'logo': CercleInfo,
            'facebook': 'https://www.facebook.com/cercleinfo?locale=fr_FR',
        },
        {
            'name': 'Cercle Math',
            'logo': CercleMath,
            'facebook': 'https://www.facebook.com/lecerclemath?locale=fr_FR',
        },
        {
            'name': 'Cercle Med',
            'logo': CercleMed,
            'facebook': 'https://www.facebook.com/CercleMedecineNamur?locale=fr_FR',
        },
        {
            'name': 'Cercle Pharma',
            'logo': CerclePharma,
            'facebook': 'https://www.facebook.com/CerclePharmaFUNDP?locale=fr_FR',
        },
        {
            'name': 'Cercle Philo',
            'logo': CerclePhilo,
            'facebook': 'https://www.facebook.com/profile.php?id=100057033956873&locale=fr_FR',
        },
        {
            'name': 'Cercle Vt',
            'logo': CercleVt,
            'facebook': 'https://www.facebook.com/cercleveterinairenamur?locale=fr_FR',
        }
    ],
    'revue': [
        {
            'name': 'Revue Droit',
            'logo': RevueDroit,
            'facebook': 'https://www.facebook.com/revuedroitnamur?locale=fr_FR',
        },
        {
            'name': 'Revue EMCP',
            'logo': RevueEMCP,
            'facebook': 'https://www.facebook.com/Revueco?locale=fr_FR',
        },
        {
            'name': 'Revue Med',
            'logo': RevueMed,
            'facebook': 'https://www.facebook.com/revuemedecineunamur?locale=fr_FR',
        },
        {
            'name': 'Revue Philo',
            'logo': RevuePhilo,
            'facebook': 'https://www.facebook.com/profile.php?id=61580341865829&locale=fr_FR',
        },
        {
            'name': 'Revue Sciences',
            'logo': RevueSciences,
            'facebook': 'https://www.facebook.com/revuesciences?locale=fr_FR',
        }
    ],
    'akap': [
        {
            'name': 'Ekot',
            'logo': Ekot,
            'facebook': 'https://www.facebook.com/ekotnamur?locale=fr_FR',
        },
        {
            'name': 'Impronam',
            'logo': Impronam,
            'facebook': 'https://www.facebook.com/kap.impronam?locale=fr_FR',
        },
        {
            'name': 'Kotéjeux',
            'logo': Kotejeux,
            'facebook': 'https://www.facebook.com/KotejeuxNamur?locale=fr_FR',
        },
        {
            'name': 'Les Bras Droits',
            'logo': LesBrasDroits,
            'facebook': 'https://www.facebook.com/lesbrasdroit?locale=fr_FR',
        },
        {
            'name': 'KapNord',
            'logo': KapNord,
            'facebook': 'https://www.facebook.com/kapnordunamur?locale=fr_FR',
        },
        {
            'name': 'Maison Internationale',
            'logo': MaisonInter,
            'facebook': 'https://www.facebook.com/kapminamur?locale=fr_FR',
        },
        {
            'name': 'KotéSport',
            'logo': KoteSport,
            'facebook': 'https://www.facebook.com/kotesport?locale=fr_FR',
        },
        {
            'name': 'Nom de la Rose',
            'logo': NomDeLaRose,
            'facebook': 'https://www.facebook.com/LeNomDeLaRoseKotAProjet?locale=fr_FR',
        },
        {
            'name': 'KotéLocal',
            'logo': KoteLocal,
            'facebook': 'https://www.facebook.com/Kot%C3%A9local-1450645691668808/?locale=fr_FR',
        },
        {
            'name': 'CoKot',
            'logo': CoKot,
            'facebook': 'https://www.facebook.com/cokotnamur?locale=fr_FR',
        },
        {
            'name': 'BioKot',
            'logo': BioKot,
            'facebook': 'https://www.facebook.com/profile.php?id=100081508959532',
        },
        {
            'name': 'Kap to Universeh',
            'logo': Universeh,
            'facebook': 'https://www.facebook.com/profile.php?id=61565527277361',
        },
        {
            'name': 'KotéMarmots',
            'logo': KoteMarmots,
            'facebook': 'https://www.instagram.com/kotemarmots_kap/',
        },
        {
            'name': 'Kaptivant',
            'logo': Kaptivant,
            'facebook': 'https://www.instagram.com/le_kaptivant/',
        },
        {
            'name': 'Une Fois Namur',
            'logo': UneFoisNamur,
            'facebook': 'https://www.instagram.com/une_fois_namur/',
        },
        {
            'name': 'Chez Marsha',
            'logo': ChezMarsha,
            'facebook': 'https://www.facebook.com/ChezMarshaNamur?locale=fr_FR',
        },
        {
            'name': 'Koté Demain',
            'logo': KoteDemain,
            'facebook': 'https://www.instagram.com/kotedemain_kap/',
        },
        {
            'name': 'Inclusio',
            'logo': Inclusio,
            'facebook': 'https://www.instagram.com/weareinclusio/',
        }
    ],
    'regios': [
        {
            'name': 'Binchoise',
            'logo': Binchoise,
            'facebook': 'https://www.facebook.com/BinchoiseNamur?locale=fr_FR',
        },
        {
            'name': 'Brabo',
            'logo': Brabo,
            'facebook': 'https://www.facebook.com/profile.php?id=100014019938212',
        },
        {
            'name': 'BW',
            'logo': BW,
            'facebook': 'https://www.facebook.com/BWNamur?locale=fr_FR',
        },
        {
            'name': 'Carolo',
            'logo': Carolo,
            'facebook': 'https://www.instagram.com/carolo_namur/',
        },
        {
            'name': 'Chimacienne',
            'logo': Chimacienne,
            'facebook': 'https://www.facebook.com/profile.php?id=100010315936291',
        },
        {
            'name': 'Destuna',
            'logo': Destuna,
            'facebook': 'https://www.facebook.com/destuna?locale=fr_FR',
        },
        {
            'name': 'Liègeoise',
            'logo': Liegeoise,
            'facebook': 'https://www.instagram.com/liegeoise_namur/',
        },
        {
            'name': 'Lux',
            'logo': Lux,
            'facebook': 'https://www.facebook.com/profile.php?id=100008487364321',
        },
        {
            'name': 'Namuroise',
            'logo': Namuroise,
            'facebook': 'https://www.facebook.com/profile.php?id=100064718370458',
        },
        {
            'name': 'RTM',
            'logo': RTM,
            'facebook': 'https://www.facebook.com/rtm.namur/?locale=fr_FR',
        }
    ]
}

export default animationData;